<template>
  <div class="how-can-i-help no-step">
    <h4 class="guide-header">Guide me in</h4>
    <div class="guide-content">
      <div class="form-group form-radio">
        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="guideMeThrough"
            id="guideMeThrough"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideMeThrough">
            selecting by product family
          </label>
        </div>

        <div v-if="canI('MULTI_LENGTH')" class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="guideSpecificLampLength"
            id="guideSpecificLampLength"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideSpecificLampLength">
            making a module combination to cover a length
          </label>
        </div>

        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="guideTunableWhite"
            id="guideTunableWhite"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideTunableWhite">
            putting together a Tunable White system
          </label>
        </div>

        <div
          class="custom-control custom-radio"
          v-if="region === 'na' || region === 'emea'"
        >
          <input
            type="radio"
            class="custom-control-input"
            value="selectEmergencyDriver"
            id="select-emergency-driver"
            name="select-emergency-driver"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="select-emergency-driver">
            selecting Emergency components
          </label>
        </div>

        <div class="custom-control custom-radio" v-if="canI('VIEW_ARCHIVE')">
          <input
            type="radio"
            class="custom-control-input"
            value="guideOldProducts"
            id="guideOldProducts"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideOldProducts">
            finding information about an old product
          </label>
        </div>

        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="guideShowFeatures"
            id="guideShowFeatures"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideShowFeatures">
            discovering the basic functions the tool offers
          </label>
        </div>

        <div class="custom-control custom-radio">
          <input
            type="radio"
            class="custom-control-input"
            value="guideShowVideos"
            id="guideShowVideos"
            v-model="howCanIHelpYou"
          />
          <label class="custom-control-label" for="guideShowVideos">
            watching the right tutorial video
          </label>
        </div>
      </div>
    </div>
    <div class="btns-container">
      <div class="right">
        <div class="btn btn-secondary" @click="next">
          Next
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "HowCanIHelp",
  data() {
    return {
      howCanIHelpYou: "guideMeThrough"
    };
  },
  computed: {
    ...mapState("brain", ["region"])
  },
  methods: {
    next() {
      switch (this.howCanIHelpYou) {
        case "guideComponentSelection":
          if (this.$router.currentRoute.name !== "advanced") {
            this.$router.push({ name: "advanced" });
          }
          this.$emit("close");
          break;
        case "guideShowFeatures":
          this.$store.commit("brain/ui/showTour", true);
          if (this.$route.name !== "advanced") {
            this.$router.push({ name: "advanced" });
          }
          this.$emit("close");
          break;
        case "guideSpecificLampLength":
          this.$emit("multiLengthGuide");
          break;
        case "selectEmergencyDriver":
          if (this.$route.name !== "emergencyDriver") {
            this.$router.push({ name: "emergencyDriver" });
          }
          this.$emit("close");
          break;
        case "guideTunableWhite":
          this.$emit("tunableWhiteGuide");
          break;
        case "guideOldProducts":
          this.$emit("oldProductsGuide");
          break;
        default:
          this.$emit("next", this.howCanIHelpYou);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.guide-content .custom-control {
  padding: 0.15rem 0 0.15rem 1.8rem !important;
}
</style>
